module.exports = __webpack_public_path__ + "img/emotion-style.e79a590.webp";